import type {ReactElement} from 'react';
import {useState} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {AddAccountIcon} from '@Components/social-media/components/add-account-icon';
import {openSocialAccountConnectionModal, PANEL_ID} from '@Modals/social-accounts-connection-modal/social-accounts-connection-modal-library';
import {Text, TextSize} from '@Components/text';
import styles from './add-account.module.scss';

interface AddAccountProps {
  onCustomAdd?: VoidFunction;
  isCompact?: boolean;
}

export function AddAccount({onCustomAdd = undefined, isCompact = false}: AddAccountProps): ReactElement | null {
  const [isLoadingState, setIsLoadingState] = useState(false);

  const onAddAccount = (): void => {
    setIsLoadingState(true);

    if (onCustomAdd !== undefined) {
      onCustomAdd();
      setIsLoadingState(false);
    } else {
      openSocialAccountConnectionModal({panelId: PANEL_ID});
      setIsLoadingState(false);
    }
  };

  const getLabel = (): ReactElement => {
    if (isCompact) {
      return <Text val={window.i18next.t('pmwjs_add_another_account')} size={TextSize.MD} bold className={styles.compactLabel} />;
    }

    return <span className="spacing-m-l-2 content-body body-md-regular">{window.i18next.t('pmwjs_add_another_account')}</span>;
  };

  return (
    <ClickableDiv className={`${styles.addAccountContainer} ${isCompact ? styles.compact : ''} flex-row-align-center _full-width`} onClick={onAddAccount}>
      <AddAccountIcon isLoading={isLoadingState} className={isCompact ? styles.compactIcon : ''} />
      {getLabel()}
    </ClickableDiv>
  );
}
